"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.elementScrollPolyfill = exports.elementScroll = void 0;
const scrollable_1 = require("../../components/scrollable");
const common_1 = require("../common");
const elementScroll = (element, options) => {
    var _a, _b, _c;
    const originalBoundFunc = common_1.original.elementScroll.bind(element);
    if (!(0, common_1.doesOverrideDefaultScrollBehavior)()) {
        originalBoundFunc(options);
        return;
    }
    if (options.left === undefined && options.top === undefined) {
        return;
    }
    const startX = element.scrollLeft;
    const startY = element.scrollTop;
    const targetX = (0, common_1.nonFinite)((_a = options.left) !== null && _a !== void 0 ? _a : startX);
    const targetY = (0, common_1.nonFinite)((_b = options.top) !== null && _b !== void 0 ? _b : startY);
    if (options.behavior !== 'smooth') {
        return originalBoundFunc(targetX, targetY);
    }
    const removeEventListener = () => {
        window.removeEventListener('wheel', cancelScroll);
        window.removeEventListener('touchmove', cancelScroll);
    };
    let duration = 400;
    if (element instanceof HTMLElement) {
        const scrollSpeed = (_c = (0, scrollable_1.getScrollable)(element)) === null || _c === void 0 ? void 0 : _c.getScrollSpeed();
        if (scrollSpeed && scrollSpeed > 0) {
            duration = scrollSpeed;
        }
    }
    const context = {
        timeStamp: (0, common_1.now)(),
        duration,
        startX,
        startY,
        targetX,
        targetY,
        rafId: 0,
        method: originalBoundFunc,
        callback: removeEventListener,
        href: window.location.href,
    };
    const cancelScroll = () => {
        cancelAnimationFrame(context.rafId);
        removeEventListener();
    };
    window.addEventListener('wheel', cancelScroll, {
        passive: true,
        once: true,
    });
    window.addEventListener('touchmove', cancelScroll, {
        passive: true,
        once: true,
    });
    (0, common_1.step)(context);
};
exports.elementScroll = elementScroll;
const elementScrollPolyfill = (animationOptions) => {
    if ((0, common_1.isScrollBehaviorSupported)()) {
        return;
    }
    const originalFunc = common_1.original.elementScroll;
    (0, common_1.modifyPrototypes)((prototype) => (prototype.scroll = function scroll() {
        if (arguments.length === 1) {
            const scrollOptions = arguments[0];
            if (!(0, common_1.isObject)(scrollOptions)) {
                throw new TypeError("Failed to execute 'scroll' on 'Element': parameter 1 ('options') is not an object.");
            }
            return (0, exports.elementScroll)(this, Object.assign(Object.assign({}, scrollOptions), animationOptions));
        }
        return originalFunc.apply(this, arguments);
    }));
};
exports.elementScrollPolyfill = elementScrollPolyfill;
//# sourceMappingURL=data:application/json;base64,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